import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  Book,
  Shield,
  Gift,
  Flower1,
  Heart,
  People,
} from 'react-bootstrap-icons';
import { FaPrayingHands } from 'react-icons/fa';

const AboutPage = () => {
  return (
    <>
      {/* ── 헤더 히어로 ── */}
      <section className="ab-hero">
        <div className="ab-hero-dharma" aria-hidden="true">☸</div>
        <Container className="ab-hero-inner">
          <span className="ab-badge">비나이다 소개</span>
          <h1 className="ab-hero-title">비나이다 공양</h1>
          <p className="ab-hero-sub">
            마음을 담아 올리는 공양,<br />
            부처님의 가르침을 따르는 실천
          </p>
          <div className="ab-hero-divider" aria-hidden="true"><span>✦</span></div>
          <p className="ab-hero-desc">
            비나이다는 사찰에 공양을 올리고자 하는 분들을 위한 안내와 참여의 장을 제공합니다.<br />
            공양은 보시의 한 형태로, 복을 짓고 마음을 정화하는 소중한 수행입니다.
          </p>
        </Container>
      </section>

      {/* ── 공양의 의미 ── */}
      <section className="ab-section ab-section--white">
        <Container>
          <div className="ab-section-header">
            <span className="ab-badge">공양의 의미</span>
            <h2 className="ab-section-title">공양의 의미와 가치</h2>
            <div className="ab-section-line" />
          </div>

          <Row className="g-4">
            <Col lg={6}>
              <div className="ab-meaning-card">
                <div className="ab-meaning-icon">
                  <Book size={28} />
                </div>
                <h3 className="ab-meaning-title">공양의 참된 의미</h3>
                <p className="ab-meaning-text">
                  공양은 단순한 물질적 나눔을 넘어, 탐욕을 버리고 자비심을 키우며
                  삼보(불, 법, 승)에 대한 깊은 존경과 감사를 표현하는 거룩한 신행 활동입니다.
                </p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="ab-meaning-card">
                <div className="ab-meaning-icon">
                  <Shield size={28} />
                </div>
                <h3 className="ab-meaning-title">비나이다가 함께하는 공양</h3>
                <p className="ab-meaning-text">
                  비나이다는 여러분의 정성스러운 공양이 원활히 이루어질 수 있도록 돕고,
                  공양의 기쁨과 그 공덕을 더 많은 분들과 함께 나누고자 합니다.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ── 인용구 띠 ── */}
      <div className="ab-quote-strip">
        <span className="ab-quote-dharma" aria-hidden="true">☸</span>
        <blockquote className="ab-quote">
          &ldquo;보시는 받는 이에게 기쁨을 주고, 주는 이의 마음을 맑게 합니다.&rdquo;
        </blockquote>
        <span className="ab-quote-dharma" aria-hidden="true">☸</span>
      </div>

      {/* ── 공양의 종류 ── */}
      <section className="ab-section ab-section--pale">
        <Container>
          <div className="ab-section-header">
            <span className="ab-badge">공양의 종류</span>
            <h2 className="ab-section-title">공양의 종류와 마음가짐</h2>
            <div className="ab-section-line" />
          </div>

          <Row className="g-4">
            {[
              {
                icon: <Gift size={26} />,
                title: '음식 공양',
                text: '정성껏 마련한 음식으로 부처님과 스님들께 공양을 올리며, 모든 생명에 대한 자비심을 기릅니다.',
              },
              {
                icon: <Flower1 size={26} />,
                title: '물품 공양',
                text: '초, 향, 꽃, 과일 등 사찰 운영과 수행에 필요한 물품을 공양하며 보시의 공덕을 쌓습니다.',
              },
              {
                icon: <Heart size={26} />,
                title: '정성된 마음',
                text: '공양물의 가치보다 올리는 이의 정성과 깨끗한 마음이 중요합니다. 감사와 존경의 마음으로 임합니다.',
              },
              {
                icon: <People size={26} />,
                title: '회향의 실천',
                text: '공양을 통해 쌓은 공덕을 자신뿐 아니라 모든 중생에게 돌리며 자비심을 넓힙니다.',
              },
            ].map((item, i) => (
              <Col md={6} lg={3} key={i}>
                <div className="ab-kind-card">
                  <div className="ab-kind-icon">{item.icon}</div>
                  <h3 className="ab-kind-title">{item.title}</h3>
                  <p className="ab-kind-text">{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ── 서비스 단계 ── */}
      <section className="ab-section ab-section--white">
        <Container>
          <div className="ab-section-header">
            <span className="ab-badge">서비스 안내</span>
            <h2 className="ab-section-title">비나이다 공양 서비스</h2>
            <div className="ab-section-line" />
          </div>

          <div className="ab-steps">
            {[
              {
                num: '01',
                title: '온라인 공양 접수',
                text: '시간과 거리의 제약 없이 비나이다를 통해 편리하게 사찰에 공양을 신청하고 동참할 수 있습니다.',
              },
              {
                num: '02',
                title: '다양한 공양 안내',
                text: '각 사찰의 특색 있는 공양 프로그램과 의미를 안내하여 뜻깊은 공양을 선택할 수 있도록 돕습니다.',
              },
              {
                num: '03',
                title: '공양 문화 확산',
                text: '전통적인 공양의 가치를 현대에 맞게 계승하고, 더 많은 분들이 공양의 기쁨을 누릴 수 있도록 노력합니다.',
              },
            ].map((step, i) => (
              <div className="ab-step" key={i}>
                <div className="ab-step-num">{step.num}</div>
                <div className="ab-step-connector" aria-hidden="true" />
                <div className="ab-step-body">
                  <h3 className="ab-step-title">{step.title}</h3>
                  <p className="ab-step-text">{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* ── CTA ── */}
      <section className="ab-cta">
        <div className="ab-cta-dharma" aria-hidden="true">☸</div>
        <Container className="ab-cta-inner">
          <FaPrayingHands className="ab-cta-icon" aria-hidden="true" />
          <h2 className="ab-cta-title">지금 바로 공양에 동참하세요</h2>
          <p className="ab-cta-desc">
            비나이다를 통해 정성스러운 마음을 전달하고, 공양의 공덕을 함께 나누세요.<br />
            여러분의 작은 정성이 큰 기쁨으로 이어집니다.
          </p>
          <Link to="/pray" className="ab-cta-btn">공양 신청하기</Link>
        </Container>
      </section>

      {/* ── 스타일 ── */}
      <style jsx="true">{`
        :root {
          --ab-teal: #009590;
          --ab-teal-dark: #007873;
          --ab-teal-pale: #e8f5f5;
          --ab-gold: #c8a96e;
          --ab-text: #2c3e35;
          --ab-muted: #6e8a84;
        }

        /* 히어로 */
        .ab-hero {
          position: relative;
          background: linear-gradient(160deg, #f0fafa 0%, #e4f5f4 60%, #d5efee 100%);
          padding: 90px 0 80px;
          text-align: center;
          overflow: hidden;
        }

        .ab-hero-dharma {
          position: absolute;
          font-size: 20rem;
          color: var(--ab-teal);
          opacity: 0.04;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          pointer-events: none;
          line-height: 1;
        }

        .ab-hero-inner {
          position: relative;
          z-index: 2;
        }

        .ab-hero-title {
          font-size: 3.2rem;
          font-weight: 700;
          color: var(--ab-teal);
          letter-spacing: -0.02em;
          margin: 14px 0 18px;
          line-height: 1.15;
        }

        .ab-hero-sub {
          font-size: 1.1rem;
          color: var(--ab-muted);
          line-height: 1.9;
          margin-bottom: 28px;
        }

        .ab-hero-divider {
          color: var(--ab-gold);
          font-size: 1rem;
          margin-bottom: 28px;
          letter-spacing: 1em;
          opacity: 0.7;
        }

        .ab-hero-desc {
          font-size: 0.97rem;
          color: #4a6660;
          line-height: 1.9;
          max-width: 640px;
          margin: 0 auto;
        }

        /* 공통 배지 */
        .ab-badge {
          display: inline-block;
          font-size: 0.72rem;
          font-weight: 700;
          letter-spacing: 0.18em;
          color: var(--ab-teal);
          text-transform: uppercase;
          margin-bottom: 12px;
          padding: 5px 14px;
          border: 1px solid var(--ab-teal);
          border-radius: 2px;
        }

        /* 섹션 공통 */
        .ab-section { padding: 80px 0; }
        .ab-section--white { background: #fff; }
        .ab-section--pale  { background: var(--ab-teal-pale); }

        .ab-section-header {
          text-align: center;
          margin-bottom: 52px;
        }

        .ab-section-title {
          font-size: 1.9rem;
          font-weight: 700;
          color: var(--ab-text);
          margin-bottom: 16px;
          letter-spacing: -0.01em;
        }

        .ab-section-line {
          width: 48px;
          height: 2px;
          background: var(--ab-teal);
          margin: 0 auto;
          opacity: 0.5;
        }

        /* 의미 카드 */
        .ab-meaning-card {
          background: #fff;
          border: 1px solid rgba(0,149,144,0.15);
          border-radius: 4px;
          padding: 40px 36px;
          height: 100%;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .ab-meaning-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 16px 36px rgba(0,149,144,0.1);
        }

        .ab-meaning-icon {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: var(--ab-teal-pale);
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--ab-teal);
          margin-bottom: 20px;
        }

        .ab-meaning-title {
          font-size: 1.15rem;
          font-weight: 700;
          color: var(--ab-text);
          margin-bottom: 14px;
        }

        .ab-meaning-text {
          font-size: 0.93rem;
          color: var(--ab-muted);
          line-height: 1.85;
          margin: 0;
        }

        /* 인용구 띠 */
        .ab-quote-strip {
          background: var(--ab-teal);
          padding: 26px 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 24px;
          flex-wrap: wrap;
        }

        .ab-quote-dharma {
          font-size: 1.4rem;
          color: rgba(255,255,255,0.45);
          flex-shrink: 0;
        }

        .ab-quote {
          font-size: 1rem;
          color: rgba(255,255,255,0.9);
          font-style: italic;
          letter-spacing: 0.02em;
          line-height: 1.7;
          margin: 0;
          text-align: center;
        }

        /* 종류 카드 */
        .ab-kind-card {
          background: #fff;
          border-radius: 4px;
          padding: 32px 24px;
          text-align: center;
          height: 100%;
          border: 1px solid rgba(0,149,144,0.12);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .ab-kind-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 14px 30px rgba(0,149,144,0.1);
        }

        .ab-kind-icon {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: var(--ab-teal-pale);
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--ab-teal);
          margin: 0 auto 18px;
        }

        .ab-kind-title {
          font-size: 1.05rem;
          font-weight: 700;
          color: var(--ab-text);
          margin-bottom: 12px;
        }

        .ab-kind-text {
          font-size: 0.86rem;
          color: var(--ab-muted);
          line-height: 1.8;
          margin: 0;
        }

        /* 단계 */
        .ab-steps {
          display: flex;
          flex-direction: column;
          gap: 0;
          max-width: 720px;
          margin: 0 auto;
        }

        .ab-step {
          display: flex;
          gap: 28px;
          align-items: flex-start;
          position: relative;
        }

        .ab-step-num {
          flex-shrink: 0;
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: var(--ab-teal);
          color: #fff;
          font-size: 0.82rem;
          font-weight: 700;
          letter-spacing: 0.05em;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          z-index: 2;
        }

        .ab-step-connector {
          position: absolute;
          left: 27px;
          top: 56px;
          width: 2px;
          height: calc(100% + 1px);
          background: rgba(0,149,144,0.18);
          z-index: 1;
        }
        .ab-step:last-child .ab-step-connector { display: none; }

        .ab-step-body {
          padding: 12px 0 48px;
        }

        .ab-step-title {
          font-size: 1.1rem;
          font-weight: 700;
          color: var(--ab-text);
          margin-bottom: 10px;
        }

        .ab-step-text {
          font-size: 0.9rem;
          color: var(--ab-muted);
          line-height: 1.85;
          margin: 0;
        }

        /* CTA */
        .ab-cta {
          position: relative;
          background: linear-gradient(135deg, #007873 0%, #009590 50%, #00b8b2 100%);
          padding: 90px 0;
          text-align: center;
          overflow: hidden;
        }

        .ab-cta-dharma {
          position: absolute;
          font-size: 18rem;
          color: rgba(255,255,255,0.05);
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          pointer-events: none;
          line-height: 1;
        }

        .ab-cta-inner {
          position: relative;
          z-index: 2;
        }

        .ab-cta-icon {
          font-size: 2.8rem;
          color: rgba(255,255,255,0.7);
          margin-bottom: 20px;
          display: block;
          margin-left: auto;
          margin-right: auto;
        }

        .ab-cta-title {
          font-size: 2rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 16px;
          letter-spacing: -0.01em;
        }

        .ab-cta-desc {
          font-size: 1rem;
          color: rgba(255,255,255,0.8);
          line-height: 1.9;
          max-width: 560px;
          margin: 0 auto 36px;
        }

        .ab-cta-btn {
          display: inline-block;
          background: #fff;
          color: var(--ab-teal);
          font-size: 0.95rem;
          font-weight: 700;
          letter-spacing: 0.04em;
          padding: 14px 40px;
          border-radius: 3px;
          text-decoration: none;
          box-shadow: 0 6px 20px rgba(0,0,0,0.15);
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }
        .ab-cta-btn:hover {
          color: var(--ab-teal-dark);
          transform: translateY(-2px);
          box-shadow: 0 10px 28px rgba(0,0,0,0.2);
        }

        /* 반응형 */
        @media (max-width: 768px) {
          .ab-hero { padding: 64px 0 56px; }
          .ab-hero-title { font-size: 2.2rem; }
          .ab-section { padding: 56px 0; }
          .ab-cta { padding: 64px 0; }
          .ab-cta-title { font-size: 1.6rem; }
          .ab-meaning-card { padding: 28px 24px; }
        }
      `}</style>
    </>
  );
};

export default AboutPage;